<template>
  <v-main>
    <MainMenu v-if="displayMenu" />
    <section id="content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <img src="img/gettyimages-1151958695-640x640.jpg" />
          </div>
          <div class="col-md-4">
            <h2 class="medium-title">Contactez nous</h2>
            <div class="information">
              <div class="contact-datails">
                <div class="icon">
                  <i class="ti-location-pin"></i>
                </div>
                <div class="info">
                  <h3>Addresse</h3>
                  <span class="detail"
                    >Sonfonia, Commune de Matoto, Conakry, République de
                    Guinée</span
                  >
                  <!--                  <span class="datail"-->
                  <!--                    >Customer Center: NO.130-45 Streen Name- City, Country</span-->
                  <!--                  >-->
                </div>
              </div>
              <div class="contact-datails">
                <div class="icon">
                  <i class="ti-mobile"></i>
                </div>
                <div class="info">
                  <h3>Numéros de téléphones</h3>
                  <span class="detail">Bureau: 664239090</span>
                  <!--                  <span class="datail"-->
                  <!--                    >Customer Supprort: +880 123 456 789-->
                  <!--                  </span>-->
                </div>
              </div>
              <div class="contact-datails">
                <div class="icon">
                  <i class="ti-location-arrow"></i>
                </div>
                <div class="info">
                  <h3>Email</h3>
                  <span class="detail"
                    >Recrutement:
                    <a href="mailto: recrutement@kirarh.fr"
                      >recrutement@kirarh.fr</a
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer v-if="displayMenu" />
  </v-main>
</template>

<script>
import MainMenu from "@/components/common/MainMenu.vue";
import Footer from "@/components/common/Footer";
export default {
  name: "Contact",
  components: { Footer, MainMenu },
  data() {
    return {
      displayMenu: false,
    };
  },
  mounted() {
    const currentUser = localStorage.getItem("currentUser");
    this.displayMenu = currentUser === null;
  },
};
</script>

<style scoped>
.v-application .info {
  background-color: white !important;
  border-color: white !important;
}
</style>
